module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentIssue) ? _c('div', {
    staticClass: "currentIssueComponent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Current Issue: "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("\n      Volume " + _vm._s(_vm.currentIssue.volume) + " , Issue " + _vm._s(_vm.currentIssue.issue) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col mb-2 pr-0"
  }, [_c('img', {
    attrs: {
      "width": "207",
      "src": _vm.currentIssue.optimized_urls.small
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col links"
  }, _vm._l((_vm.currentIssue.rubricLinks), function(link) {
    return _c('router-link', {
      key: link.url,
      staticClass: "link",
      attrs: {
        "to": link.url
      }
    }, [_vm._v(_vm._s(link.text)), _c('i', {
      staticClass: "icon icon-color-arrow-right"
    })])
  }))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ea6133f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/sidebar/SidebarCurrentIssueComponent.vue
// module id = 1389
// module chunks = 1